import styled from 'styled-components';

export const ErrorPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  padding: 20px;
  overflow-y: auto;

  > p {
    margin: 0;
    padding: 20px 0;
  }
`;
